module.exports = __webpack_public_path__ + "img/pad-fill-profile-goal-slide3.b78bf4b1.gif";